import React from 'react'
import { FeaturedProps } from '@toasttab/shared/src/components/molecules/CardTypes/types.d'
import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import StyledList from '@toasttab/shared/src/components/molecules/StyledList/StyledList'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import { Card, Text } from '@toasttab/shared/src/utils/craftUtils'

const FeaturedCard = ({
  heading,
  description,
  badgeColor,
  badgeText,
  listItems,
  button,
  backgroundColor,
  borderColor,
  elevation,
  padding,
  textAlignment
}: FeaturedProps) => {
  return (
    <div
      className={`${backgroundColor} relative overflow-hidden border ${Card.borderColor(
        borderColor
      )} ${Card.elevation(elevation)} ${Text.alignment(
        textAlignment
      )} ${Card.cardPadding(padding)} rounded-md`}
      data-testid='featuredcard'
    >
      <Typography variation='h4' as='h4' classes='text-default mb-4'>
        {heading}
      </Typography>
      <p className='text-gray-100 mb-4' data-testid='description'>
        {description}
      </p>
      <div
        className={`${badgeColor} inline-flex mb-10 mx-auto px-6 py-1.5 rounded-[30px] text-gray-125 text-[.75] font-semibold leading-[.875rem]`}
        data-testid='badge'
      >
        {badgeText}
      </div>
      <StyledList
        listOnly
        sectionHeading=''
        sectionDescription=''
        listVariation='heading-only'
        listStyles='none'
        listItems={listItems}
      />
      <Button
        href={button.link}
        classes={`!w-full mt-4`}
        size={button.size}
        variation={button.variant}
      >
        {button.label}
      </Button>
    </div>
  )
}

export default FeaturedCard
